module.exports = __webpack_public_path__ + "img/hx.b993292f.png";